import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { SalatiActivationRequest } from './salatiactivationrequest';

export class SalatiActivationAPI extends SixdeeCRBTAPI<SalatiActivationRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/salati-activation
        return "salati-activation";
    }

    getRequestData()
    {
        return "clientTxnId=21042020"+"&"+
               "serviceId=" + this.getRequest().getSalatiActivationRequest().getServiceId() +"&"+
               "activityId="+ this.getRequest().getSalatiActivationRequest().getActivityId() +"&"+
               "aPartyMsisdn=" + this.getRequest().getSalatiActivationRequest().getAPartyMsisdn() +"&"+
               "paymentMode="+ this.getRequest().getSalatiActivationRequest().getPaymentMode()+"&"+
               "channelId="+ this.getRequest().getSalatiActivationRequest().getChannelId()+"&"+
               "language="+ this.getRequest().getSalatiActivationRequest().getLanguage()+"&"+
               "priority="+ this.getRequest().getSalatiActivationRequest().getPriority();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/salati/salatiactivation/salatiactivationapi.tsx